G.ActionShuffle = function(board,am,args) {

	G.Action.call(this,board,am,args);

	this.state = game.state.getCurrentState();
  this.board = this.state.board;

  this.shuffleText = new G.Text(0, 0, OMT.language.getText('No possible match - shuffling'), {
  style: G.OMTsettings.global.jungleMatch || G.OMTsettings.global.hawaiiMatch ? 'font-white' : 'font-white',
    fontSize: "70px",
  }, 0.5, 620);

	// this.shuffleText.x = this.state.board.x+this.state.board.width*0.5;
	// this.shuffleText.y = this.state.board.y+this.state.board.height*0.47;
  this.shuffleText.position.setTo(
    this.board.x+(this.board.width-this.board.tilesize*2)*0.5,
    this.board.y+(this.board.height-this.board.tilesize*2)*0.45
  );
	game.state.getCurrentState().UIFxLayer.add(this.shuffleText);
  this.shuffleText.scale.setTo(0);
  game.add.tween(this.shuffleText.scale)
    .to({x: 1, y: 1}, 400, Phaser.Easing.Elastic.Out, true);
	// this.shuffleText.popUpAnimation();

	this.updateActive = false;

	game.add.tween(this.shuffleText)
    .to({alpha:0},G.IMMEDIATE ? 1 : 300,Phaser.Easing.Sinusoidal.Out,true,G.IMMEDIATE ? 10 : 2000)
    .onComplete.add(function() {
  		this.board.shuffleCandies();
  		this.updateActive = true;
  		this.shuffleText.destroy();
  	},this);
	

	

};

G.ActionShuffle.prototype = Object.create(G.Action.prototype);

G.ActionShuffle.prototype.update = function() {

	if (this.updateActive) {

		if (!this.board.duringAnimation && !this.board.duringFall) {
			
			this.updateActive = false;

			if (this.board.checkMatchList.length == 0) {
				this.finish()
			}else {
				if (G.IMMEDIATE) {
					this.finish();
				}else {
					game.time.events.add(300,this.finish,this);
				}
			}
			

		};

	}

};